import { createSlice } from "@reduxjs/toolkit"
import {
  changePassword,
  forgotPassword,
  getProfileDetails,
  login,
  otpVerification,
} from "store/actions/authAction"

const initialState = {
  isLoggedIn: false,
  loading: false,
  isLoading: null,
  userDetails: {},
  userType: localStorage.getItem("userType") || "",
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(login.pending, state => {
        state.isLoading = true
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false
        const { success } = action.payload
        if (success) {
          const { data } = action.payload
          console.log(data)
          state.userDetails = data
          state.isLoggedIn = true
          state.userType = data.user_type // candidate,
          // state.userType = "candidate" // candidate,

          localStorage.setItem("authUser", JSON.stringify(data))
          localStorage.setItem("isLoggedIn", true)
          localStorage.setItem("userType", data.user_type)
          localStorage.setItem("uuid", data.uuid)
        }
      })
      .addCase(login.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(forgotPassword.pending, state => {
        state.isLoading = true
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(forgotPassword.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(otpVerification.pending, state => {
        state.isLoading = true
      })
      .addCase(otpVerification.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(otpVerification.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(changePassword.pending, state => {
        state.isLoading = true
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(changePassword.rejected, state => {
        state.isLoading = false
      })

    builder
      .addCase(getProfileDetails.pending, state => {
        state.loading = true
      })
      .addCase(getProfileDetails.fulfilled, (state, action) => {
        state.loading = false
        const { success } = action.payload
        if (success) {
          const { data } = action.payload
          state.userDetails = data
        }
      })
      .addCase(getProfileDetails.rejected, state => {
        state.loading = false
      })
  },
})

export default authSlice.reducer
